<template>
  <div class="base-skeleton" :class="{ 'is-loading': loading }">
    <template v-if="loading">
      <div v-if="type === 'card'" class="skeleton-card">
        <a-skeleton :animation="animation">
          <a-space direction="vertical" :style="{ width: '100%' }" size="large">
            <a-skeleton-line :rows="1" :line-height="200" />
            <a-skeleton-line :rows="3" />
          </a-space>
        </a-skeleton>
      </div>
      <div v-else-if="type === 'list'" class="skeleton-list">
        <a-skeleton :animation="animation">
          <a-space direction="vertical" :style="{ width: '100%' }" size="large">
            <a-skeleton-line v-for="i in 3" :key="i" :rows="2" />
          </a-space>
        </a-skeleton>
      </div>
      <div v-else class="skeleton-default">
        <a-skeleton :animation="animation">
          <a-skeleton-line :rows="rows" />
        </a-skeleton>
      </div>
    </template>
    <slot v-else />
  </div>
</template>

<script setup>
/**
 * @description 基础骨架屏组件，封装 Arco Design 的 Skeleton
 * @param {boolean} loading - 是否显示加载状态
 * @param {string} type - 骨架屏类型：'default' | 'card' | 'list'
 * @param {number} rows - 默认类型的行数
 * @param {boolean} animation - 是否启用动画
 */
defineProps({
  loading: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: 'default',
  },
  rows: {
    type: Number,
    default: 3,
  },
  animation: {
    type: Boolean,
    default: true,
  },
})
</script>

<style lang="scss" scoped>
.base-skeleton {
  width: 100%;

  .skeleton-card {
    padding: 1rem;
    border: 1px solid var(--color-border);
    border-radius: var(--border-radius-medium);
  }

  .skeleton-list {
    width: 100%;
  }
}
</style>
